import * as React from "react";
import {jfetch, toast} from "../../utils";
import KeyForm from "../permissions/KeyForm";
import {useState, useEffect} from "react";
import { error } from "console";

interface iProps{
  setGroups: Function;
  setShowKeyEdit: Function;
  setTools: Function;
  setCourses: Function;
  setFolders: Function;
  name:string;
  desc:string;
  setName: Function;
  setDesc: Function;
  loading: boolean;
  setLoading: Function
  tools: any;
  tools2: any;
  courses: any;
  courses2: any;
  folders: any;
  folders2: any;
  power: Function;
  toggle_tool: Function;
  toggle_course: Function;
  toggle_folder: Function;
  groupID: number;
}



function KeyEdit(props:iProps){
  function handleSave(){
    props.setLoading(true)
    let tool_keys = []
    let course_keys = []
    let folder_keys = []
    props.tools.forEach(tool => {
      if(tool.access == true){
        let t = {global:false, access:true, keyable_id:tool.id, keyable_type:"Tool"}
        tool_keys.push(t)
      }
    });
    props.courses.forEach(course => {
      if(course.access == true){
        let c = {global:false, access:true, keyable_id:course.id, keyable_type:"Library::Course"}
        course_keys.push(c)
      }
    });
    props.folders.forEach(folder => {
      if(folder.access == true){
        let f = {global:false, access:true, keyable_id:folder.id, keyable_type:"ResourceCategory"}
        folder_keys.push(f)
      }
    });
    let data = {
      group: {name:props.name, desc:props.desc},
      tool_keys: tool_keys,
      course_keys: course_keys,
      folder_keys: folder_keys
    }
    jfetch
    .patch(`/permissions/groups/${props.groupID}`, data)
    .then((resp) => {
      toast.success('Updated!')
      let groups = []
      resp.data.data.forEach(g => {
        groups.push(g.attributes)
      });
      props.setGroups(groups)
      props.setLoading(false)      
    })
    .catch((error) => {
      toast.error("error saving updates")
      props.setLoading(false)
    })
  }

  function init(){
    // console.log('init ran')
  }

  return (
    <KeyForm 
      setTools={(val) => props.setTools(val)}
      setGroups={(val) => props.setGroups(val)} 
      setCourses={(val) => props.setCourses(val)}
      setFolders={(val) => props.setFolders(val)}
      name={props.name}
      desc={props.desc}
      setName={(val) => props.setName(val)}
      setDesc={(val) => props.setDesc(val)}
      loading={props.loading}
      setLoading={(val) => props.setLoading(val)}
      tools={props.tools}
      tools2={props.tools2}
      courses={props.courses}
      courses2={props.courses2}
      folders={props.folders}
      folders2={props.folders2}
      power={props.power}
      toggle_tool={props.toggle_tool}
      toggle_course={props.toggle_course}
      toggle_folder={props.toggle_folder}
      handleSave={handleSave}
      init={init}
    />
  )     
}

export default KeyEdit


// WEBPACK FOOTER //
// ./app/javascript/components/permissions/KeyEdit.tsx